import "./SummaryCard.css";
import { FaInfoCircle } from "react-icons/fa";

function SummaryCard({title, cardtime, info = ""}) {
  return (
    <div className="summaryCard">
      <div className="summaryCardTitle">
        <h5>{title} <FaInfoCircle title={info} size={16}/></h5>
      </div>
      <div className="summaryCardValue">{cardtime || 0}</div>
    </div>
  );
}

export default SummaryCard;
